import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "../constants/site";

const LINKS = [
  { label: "Destinations", href: "#destinations", testid: "nav-link-destinations" },
  { label: "Visas", href: "#visas", testid: "nav-link-visas" },
  { label: "Why Us", href: "#why-us", testid: "nav-link-why-us" },
  { label: "Pay", href: "#pay", testid: "nav-link-pay" },
  { label: "Contact", href: "#contact", testid: "nav-link-contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    scrollToId(e, href);
    setOpen(false);
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled || open ? "border-b border-white/10 bg-black/70 backdrop-blur-xl" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 md:px-10">
        <a
          href="#top"
          onClick={(e) => go(e, "body")}
          data-testid="nav-logo"
          className="flex items-center gap-3"
        >
          <img src="/assets/gautam-logo.png" alt="Gautam Travel logo" data-testid="nav-logo-img" className="h-11 w-auto md:h-12" />
          <span className="flex flex-col leading-none">
            <span className="font-display text-2xl tracking-wide">
              Gautam<span className="italic text-sunset">Travel</span>
            </span>
            <span className="mt-1 text-[9px] uppercase tracking-[0.4em] text-white/40">Est. 2014</span>
          </span>
        </a>

        <nav className="hidden items-center gap-10 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={l.testid}
              className="text-xs uppercase tracking-[0.25em] text-white/60 transition-colors duration-300 hover:text-sunset"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={(e) => go(e, "#contact")}
            data-testid="nav-cta-btn"
            className="rounded-full bg-sunset px-6 py-2.5 text-xs font-semibold uppercase tracking-[0.2em] text-ink transition-colors duration-300 hover:bg-coral"
          >
            Plan My Trip
          </a>
        </nav>

        <button
          onClick={() => setOpen(!open)}
          data-testid="nav-menu-toggle"
          aria-label="Toggle menu"
          className="text-white lg:hidden"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <nav data-testid="nav-mobile-menu" className="border-t border-white/10 bg-black/90 px-6 py-8 backdrop-blur-xl lg:hidden">
          <div className="flex flex-col gap-6">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => go(e, l.href)}
                data-testid={`${l.testid}-mobile`}
                className="font-display text-3xl text-white/80 transition-colors duration-300 hover:text-sunset"
              >
                {l.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
};
